/**
 * A clip's duration for display. An unmeasured duration (null/undefined, 0 or
 * negative) is UNAVAILABLE — returned as null so the page omits it — never
 * rendered as "0:00".
 */
export function formatDuration(seconds: number | null | undefined): string | null {
  if (typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds <= 0) return null;
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}
